import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeCopyAteNumbersDialog, confirmCopyAteNumbers } from './copyAteNumbersDucks';
import { Field, reduxForm } from 'redux-form';
import { formName } from './copyAteNumbersFormUtils';
import Input from '../../../commons/components/input/Input';
import { parseToInt } from '../../../commons/redux-form/valueParser';
import { normalizePositiveNumber } from '../../../commons/redux-form/valueNormalizer';
import { getCopyAteNumbersState } from '../../../commons/selectors/selectors';
import { getCountryName } from '../../../commons/countries/foreignCountries';

const validateFromWagon = (fromWagon, { toWagon }) => {
  if (!Number.isInteger(fromWagon)) {
    return 'Champ obligatoire';
  }
  if (fromWagon < 1) {
    return 'Minimum 1';
  }
  if (fromWagon > toWagon) {
    return 'Le premier wagon ne peut pas être après le dernier wagon';
  }
};

const validateToWagon = (toWagon, { fromWagon }) => {
  if (!Number.isInteger(toWagon)) {
    return 'Champ obligatoire';
  }
  if (toWagon < 1) {
    return 'Minimum 1';
  }
  if (fromWagon > toWagon) {
    return 'Le dernier wagon ne peut pas être avant le premier wagon';
  }
};

const CopyAteNumbersModal = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const { open, frenchAteNumber, foreignAteCountry, foreignAteNumber, speedLimit } =
    useSelector(getCopyAteNumbersState);
  if (!open) {
    return null;
  }
  const onClose = () => dispatch(closeCopyAteNumbersDialog());
  return (
    <form onSubmit={handleSubmit((values) => dispatch(confirmCopyAteNumbers(values)))} autoComplete="off">
      <div className="modal large">
        <div className="modal-fade" onClick={onClose} />
        <div className="modal-body">
          <div className="modal-title">Propager le transport exceptionnel aux autres wagons ?</div>
          <div className="modal-content">
            <strong>Numéro ATE ou gabarit français :</strong> {frenchAteNumber ?? ''}
            <br />
            <strong>Vitesse max. pour transport exceptionnel :</strong> {speedLimit ?? ''} km/h
            <br />
            <strong>Numéro ATE ou gabarit étranger :</strong> {foreignAteNumber ?? ''}
            <br />
            <strong>Pays :</strong> {getCountryName(foreignAteCountry) ?? ''}
            <br />
          </div>
          <div className="columns">
            <Field
              name="fromWagon"
              component={Input}
              type="text"
              pattern="[0-9]*"
              parse={parseToInt}
              normalize={normalizePositiveNumber}
              maxLength={2}
              className="right"
              labelText="Du wagon"
              validate={validateFromWagon}
            />
            <Field
              name="toWagon"
              component={Input}
              type="text"
              autoFocus={true}
              pattern="[0-9]*"
              parse={parseToInt}
              normalize={normalizePositiveNumber}
              maxLength={2}
              className="right"
              labelText="Au wagon"
              validate={validateToWagon}
            />
          </div>
          <button type="submit" className="modal-btn success">
            Propager
          </button>
          <button type="button" className="modal-btn modal-btn-cancel" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: formName,
})(CopyAteNumbersModal);
